
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/saved",
      function () {
        return require("private-next-pages/saved/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/saved"])
      });
    }
  